import React from 'react';

const ReviewsPagePlaceholder = React.memo(()=> {
	return <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 my-6">
		<div className="col-span-2">
			<div className="overflow-hidden rounded-lg bg-white/5 border border-gray-200 p-6">
				<ul className="space-y-3">
					<li className="w-3/4 h-7 bg-gray-200 rounded-md"></li>
					<li className="w-1/2 h-7 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-5 bg-gray-200 rounded-md"></li>
				</ul>
			</div>
		</div>
		<div className="col-span-2 md:col-span-1">
			<div className="overflow-hidden rounded-lg bg-white/5 border border-gray-200 p-6">
				<ul className="space-y-3">
					<li className="w-1/3 h-5 bg-gray-200 rounded-md"></li>
					<li className="w-1/2 h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
				</ul>
			</div>
		</div>
		<div className="col-span-2 md:col-span-1">
			<div className="overflow-hidden rounded-lg bg-white/5 border border-gray-200 p-6">
				<ul className="space-y-3">
					<li className="w-1/3 h-5 bg-gray-200 rounded-md"></li>
					<li className="w-1/2 h-5 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
					<li className="w-full h-4 bg-gray-200 rounded-md"></li>
				</ul>
			</div>
		</div>
	</div>
});

export default ReviewsPagePlaceholder;